export default {
  setEnterInfo(state, enterInfo) {
    state.enterInfo = enterInfo
  },
  setCategoryList4Entering(state, categoryList4Entering) {
    state.categoryList4Entering = categoryList4Entering
  },
  resetServiceList(state) {
    state.serviceList = []
  },
  setCredentialList(state, credentialList) {
    state.credentialList = credentialList
  },
  setServerCity(state, serverCity) {
    state.serverCity = serverCity
  },
  setServerArea(state, serverArea) {
    state.serverArea = serverArea
  },
  setOriginPlace(state, originPlace) {
    state.originPlace = originPlace
  },
  setRewards(state, list) {
    state.rewards.push(...(list || []))
  },
  resetRewards(state) {
    state.rewards = []
  },
  setNearbyStore(state, nearbyStore) {
    state.nearbyStore = nearbyStore
  }
}
